var acc = document.getElementsByClassName("n_accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("n_active");
    var n_panel = this.nextElementSibling;
    if (n_panel.style.maxHeight) {
      n_panel.style.maxHeight = null;
    } else {
      n_panel.style.maxHeight = 5000 + "px";
    }
  });
};